import { useQuery } from '@tanstack/react-query'

import { FetchOrganization } from '@/services/OrganizationService'

export const useOrganization = (orgId: string) => {
  return useQuery({
    queryKey: ['organization', orgId],
    queryFn: () => FetchOrganization(orgId),
    enabled: Boolean(orgId),
  })
}
